// extracted by mini-css-extract-plugin
module.exports = {"scenePartnerCalc":"bk_g4","scenePartnerCalc__sliderHelperIcon":"bk_g5","scenePartnerCalc__total":"bk_g6"};